import { faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { iff } from '»utils/code';

import { ButtonTradingStyled } from '../Styles';

export const ButtonMinus = ({ isCard, isGrid, onClick, disabled }) => (
  <ButtonTradingStyled
    isCard={isCard}
    isGrid={isGrid}
    onClick={onClick}
    disabled={disabled}
  >
    <FontAwesomeIcon
      style={{ fontSize: isCard ? 20 : iff(isGrid, 12, 25) }}
      icon={faMinus}
    />
  </ButtonTradingStyled>
);
ButtonMinus.propTypes = {
  isCard: PropTypes.bool,
  isGrid: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
